import { selectedHouseData, selectedRoomData, selectedRoomAllDevices, selectedDeviceData, clearDropdownData, selectedDeviceTypeData } from "../actionTypes"

export const dropdownSelectionData = (state = {
    houseId: '',
    roomId: '',
    // The dashboard's Device Type pick. roomId is what the older pages read.
    deviceType: '',
    devices: [],
    selectedDeviceDetails: {}
}, action) => {
    const { type, payload } = action

    switch (type) {
        case selectedHouseData.LOAD_SELECTED_HOUSE_DATA:
            return { ...state, houseId: payload }
        case selectedRoomData.LOAD_SELECTED_ROOM_DATA:
            return { ...state, roomId: payload }
        case selectedDeviceTypeData.LOAD_SELECTED_DEVICE_TYPE:
            return { ...state, deviceType: payload }
        case selectedRoomAllDevices.LOAD_SELECTED_ROOM_DEVICES:
            return { ...state, devices: payload }
        case selectedDeviceData.LOAD_SELECTED_DEVICE_DATA:
            return { ...state, selectedDeviceDetails: payload }
        case clearDropdownData.CLEAR_DATA:
            return {
                roomId: '',
                deviceType: '',
                devices: [],
                selectedDeviceDetails: {}
            }
        default:
            return state
    }
}